import api from "@services/recAxiosInstance";
import buildFullPath from "axios/lib/core/buildFullPath";

const cacheName = "recommendation";

async function getGenreData(genre) {
  var fullPath = buildFullPath(
    process.env.VUE_APP_REC_URL,
    "/query/genre/" + genre
  );
  if ("caches" in window) {
    try {
      const cache = await caches.open(cacheName);
      const responsec = await cache.match(fullPath);
      if (responsec) {
        // If there is an entry in the cache for event.request, then response will be defined
        // and we can just return it. Note that in this example, only font resources are cached.

        let object = await responsec.json();
        // console.log(" Found response in cache:", object);

        if (responsec.status == 200) {
          return { data: object };
        } else {
          return api.get("/query/genre/" + genre);
        }
      } else {
        return api.get("/query/genre/" + genre);
      }
    } catch (error) {
      return api.get("/query/genre/" + genre);
    }
  }
  return api.get("/query/genre/" + genre);
}

export default {
  getGenreData,
};
